import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidateId } from '../../id-validator';
import { requiredLengthValidator } from '../../required-length.validator';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})

export class LoginPageComponent implements OnInit {
  wasIntroClicked = false;
  idSendForm: FormGroup;
  @Output() idFormFilled: EventEmitter<string> = new EventEmitter;
  submitted: boolean = false;

  constructor(
    private formBuilder: FormBuilder) {
  }
  ngOnInit(): void {
    this.idSendForm = this.formBuilder.group({
      id: ['', [Validators.required, requiredLengthValidator(9), ValidateId]]
    });
  }

  login() {
    this.submitted = true;
    if (this.idSendForm.valid) {
      this.idFormFilled.emit(this.idSendForm.value.id);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login-page/login-page.component.ts